<div class="h-full flex flex-col gap-4 oveflow-y-auto">

    <div class="w-full flex flex-row items-center justify-between">
        <h2 class="font-heading text-md font-bold leading-none tracking-tight">Select Product</h2>
        <button type="button" (click)="mode.set('new')"
            class="btn-shout btn-shout-xs btn-shout-primary inline-flex items-center gap-x-2 transition-all ease-in-out duration-300">
            Add new Product
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
                <path d="M5 12h14" />
                <path d="M12 5v14" />
            </svg>
        </button>
    </div>

    @if (mode() === 'existing') {
        @if (createScreeningService.selectedProduct(); as product) {
        <div
            class="flex items-center gap-3.5 rounded-lg border-2 border-brand-studio bg-brand-studio/[0.06] p-3.5 ring-2 ring-brand-studio/20">
            @if (product.productImage) {
            <img [src]="imageService.getImageSource(product.productImage, 'gallery')"
                class="size-14 flex-shrink-0 rounded-md border border-border object-cover" alt="" />
            }
            <div class="min-w-0 flex-1">
                <div class="font-heading text-[17px] font-bold leading-tight">{{ product.productName }}</div>
                <div class="mt-1 truncate text-xs text-muted-foreground">{{ product.productCategory }}{{ product.website ? '
                    · ' + product.website : '' }}</div>
            </div>
            <button type="button" class="secondary-button" (click)="clearSelection()">Change</button>
        </div>

        <div class="flex flex-col gap-2.5 mt-6">
            <div>
                <h3 class="font-heading text-md font-bold leading-none tracking-tight">
                    Would you like to add additional product images?
                </h3>
                <p class="mt-1 text-sm text-muted-foreground">
                    Using our advanced models, adding brand logos and product images will improve the quality of the
                    screening.
                </p>
            </div>

            <div class="flex flex-wrap items-start gap-2.5">
                <atom-add-image [bucket]="S3Bucket.PRODUCT_IMAGES" [clearOnUpload]="true" [size]="'sm'"
                    (imageUploaded)="onImageUploaded($event)"></atom-add-image>

                @for (image of displayAdditionalProductImages(); track image) {
                <div class="relative">
                    <button type="button" (click)="onImageDelete(image)"
                        class="absolute -right-2 -top-2 z-10 btn-fab-delete" aria-label="Remove image">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-4">
                            <path d="M18 6 6 18" />
                            <path d="m6 6 12 12" />
                        </svg>
                    </button>

                    <atom-ldg-img inputClass="size-14 rounded-md border border-border object-cover" w="full"
                        radius="md" [src]="imageService.getImageSource(image, 'gallery')"></atom-ldg-img>
                </div>
                }
            </div>
        </div>
        } @else {
        @if (loading()) {
        <!-- <p class="text-sm text-muted-foreground">Loading your products…</p> -->
        <div class="w-full flex flex-row items-center justify-center">
            <div class="text-center">
                <svg aria-hidden="true"
                    class="mx-auto w-16 h-16 text-primary/15 animate-spin dark:text-gray-600 fill-primary"
                    viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor" />
                    <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentFill" />
                </svg>
                <h3 class="mt-2 text-sm font-semibold text-gray-900 dark:text-white">Loading...</h3>
                <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">Fetching your products</p>
            </div>
        </div>
        } @else if (!products().length) {
        <p class="text-sm text-muted-foreground">No saved products yet — switch to “Add new product”.</p>
        } @else {
        <div class="flex flex-col gap-2.5">
            @for (product of products(); track product.id) {
            <button type="button" (click)="selectProduct(product)"
                class="flex w-full items-center gap-3.5 rounded-lg border border-border bg-card p-3.5 text-left transition-colors hover:border-foreground/30">
                @if (product.productImage) {
                <img [src]="imageService.getImageSource(product.productImage, 'gallery')"
                    class="size-14 flex-shrink-0 rounded-md border border-border object-cover" alt="" />
                }
                <div class="min-w-0 flex-1">
                    <div class="font-heading text-[17px] font-bold leading-tight">{{ product.productName }}</div>
                    <div class="mt-1 truncate text-xs text-muted-foreground">{{ product.productCategory }}</div>
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="text-muted-foreground">
                    <path d="m9 18 6-6-6-6" />
                </svg>
            </button>
            }
        </div>
    
        }
        }
        }
</div>